import type { BudgetPreviewsWrapperProps } from './types'

import * as S from './styles'

export const BudgetPreviewsWrapper = ({ children }: BudgetPreviewsWrapperProps) => {
  return <S.Container>{children}</S.Container>
}
